import React from "react";
import { Outlet } from "react-router-dom";

/**
 * Router-Shell: rendert nur Outlet; Child-Routes werden vom Host (Manifest/Loader) gemappt.
 */
export function ClubmeisterschaftRoot() {
  return <Outlet />;
}
